export default "__VITE_ASSET__DUJgRsgP__"